import ConsentTemplatesPanel from "@/components/consent/ConsentTemplatesPanel";

export default function ConsentTemplatesPage() {
  return <ConsentTemplatesPanel />;
}
